import store from '@/store/index.js'
let dic = store.state.dic;
import { getOrgOptions } from "@/libs/searchSelect.js";
export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 6,
            type: 'select',
            model: "collegeId",
            options: [],
            clearable: true,
            change(data) {
                // console.log(data)
                let params = {
                    parentId: data,
                    type: 'department'
                }
                that.searchItems[1].options = [];
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.departmentId = "";
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 1, null)
                }
            },
        },
        {
            label: "系别",
            span: 6,
            type: 'select',
            model: "departmentId",
            options: [],
            clearable: true,
            change(data) {
                let params = {
                    parentId: data,
                    type: 'major'
                }
                that.searchItems[2].options = [];
                that.searchItems[3].options = [];
                that.pageParams.majorId = "";
                that.pageParams.classId = "";
                if (data) {
                    getOrgOptions(that, params, 2, null)
                }
            },
        },
        {
            label: "专业",
            span: 6,
            type: 'select',
            model: "majorId",
            options: [],
            clearable: true,
            change(data) {
                console.log(data)
                let params = {
                    parentId: data,
                    type: 'class'
                }
                that.searchItems[3].options = [];
                that.pageParams.classId = '';
                if (data) {
                    getOrgOptions(that, params, 3, null)
                }
            },
        },
        {
            label: "班级",
            span: 6,
            type: 'select',
            model: "classId",
            options: [],
            clearable: true,
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 6,
            placeholder: '请输入学号',
            model: "studentNo",
        },
        {
            label: "身份证号",
            span: 6,
            placeholder: '请输入身份证号',
            model: "idCard",
        },
        {
            label: "姓名",
            span: 6,
            placeholder: '请输入姓名',
            model: "studentName",
        },
        {
            label: "是否已应征入伍",
            span: 6,
            labelWidth: '120px',
            type: 'select',
            model: "isOrNot",
            options: dic._IS,
            clearable: true,
        },
    ]
    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            minWidth: 140,
            show: true
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            minWidth: 180,
            show: true
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            show: true
        },
        {
            label: "性别",
            prop: "sex",
            align: "center",
            show: true
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            minWidth: 180,
            show: true
        },
        // {
        //     label: "系别",
        //     prop: "departmentName",
        //     align: "center",
        //     minWidth: 180,
        //     show: true
        // },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            minWidth: 260,
            show: true
        },
        // {
        //     label: "班级",
        //     prop: "className",
        //     align: "center",
        //     minWidth: 160,
        //     show: true
        // },
        {
            label: "办理状态",
            prop: "status",
            align: "center",
            minWidth: 140,
            show: true
        },
        {
            label: "是否已应征入伍",
            name: 'status',
            align: "center",
            minWidth: 140,
            show: true
        },
        // {
        //     label: "操作",
        //     name: "custom",
        //     align: "center",
        //     width: '260px',
        //     show: true
        // }
    ]

    return {
        searchItems,
        tableColumns
    }
}
